module.exports = "<app-notice-cookies></app-notice-cookies>\n<div idleDetect class=\"h-100\">\n  <router-outlet></router-outlet>\n</div>\n"